<template>
  <layout-main-inner title="模板管理">
    <layout-card-wrap hasHeaderSlot
      v-loading="loading">
      <template slot="form">
        <el-input placeholder="请输入模板名称"
          v-model="config.vacFieldLibName"
          style="width: 200px">
          <el-button slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table border
        :data="list">
        <el-table-column label="模板名称">
          <template slot-scope="{row}">
            <link-route @click.native="clibInfo(row)">
              {{row.vacFieldLibName}}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column label="模板类别">
          <template slot-scope="{row}">
            {{row.fieldCode === 'wxPublicAccount' ? '公众号' : '图文内容'}}
          </template>
        </el-table-column>
        <el-table-column label="最近更新时间"
          width="200">
          <template slot-scope="{row}">
            {{ row.updatedTime | dateformat('YYYY-MM-DD hh:ss:mm')}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
          width="120">
          <template slot-scope="{row}">
            <el-button type="text"
              @click="editclib(row)">编辑</el-button>
            <el-button type="text"
              @click="deletevaclib(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
          @current-change="handleCurrentChange"
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
    <clib-detail-modal ref="modal" />
    <clib-edit-modal ref="modal1"
      :fecth="fetchList" />
  </layout-main-inner>
</template>

<script>
import ClibDetailModal from './busi/clib-detail-modal.vue'
import ClibEditModal from './busi/clib-edit-modal.vue'
import { mapState } from 'vuex'
export default {
  name: 'material-list',
  components: { ClibDetailModal, ClibEditModal },
  props: {},
  data () {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        vacFieldLibName: '',
        vendorId: this.$route.query.vendorId
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  methods: {
    clibInfo (row) {
      this.$refs.modal.toggleModal(true)
      this.$refs.modal.getvaclib(row.vacFieldLibId, row.vendorId)
    },
    editclib (row) {
      this.$refs.modal1.toggleModal(true)
      this.$refs.modal1.getvaclib(row.vacFieldLibId, row.vendorId)
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('vas/getvaclibs', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deletevaclib (row) {
      this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('vas/deletevaclib', {
            payload: {
              vacFieldLibId: row.vacFieldLibId,
              vendorId: row.vendorId
            },
            success: (res) => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  },
  created () {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
